export default "/_next/static/chunks/fonts/Outfit Thin-2036ad775363105e11d7b7c6c35d9352.ttf";